import React from 'react';
import {Divider} from "antd";
import {Link} from "react-router-dom";
import Locale from "../util/Locale";

function Footer() {
    return (
        <div>
            <footer className="p-4 md:p-6 lg:p-8 dark:bg-gray-800 logo-dark-bg">
                <div className="mx-auto max-w-screen-xl text-center">
                    <p className="mb-6 text-white dark:text-white theme-font">Care for your business</p>
                    <div>
                        <a className="text-sm text-gray-500 sm:text-center dark:text-gray-400"
                            href="mailto:info@kernis.sk"><Locale code={'footer.contact'}/>: info@kernis.sk</a>
                    </div>
                    <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
                        © 2024  <a href="#" className="hover:underline">KERNIS</a> <Divider type={'vertical'}
                                                                                            className={'border-gray-700'}/> <Link
                        to={'/gdpr'}><Locale code={'footer.gdpr'}/></Link>
                    </span>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
